import { composition } from '@/utils/composition';
import { transformIntlMessages } from '@/utils/transformIntlMessages';

import common from './common';
import modals from './modals';
import menus from './menus';
import myTools from './pages/my-tools';
import emailFeedback from './pages/email-feedback';
import programStatus from './pages/program-status';
import appIntegrations from './pages/app-integrations';
import coinLoyaltySettings from './pages/features/coin-loyalty-settings';
import referralProgram from './pages/features/referral-program';
import performance from './pages/performance';
import emailAutomation from './pages/features/email-automation';
import sellCoins from './pages/features/sell-coins';
import customerImport from './pages/features/customer-import';
import offers from './pages/features/offers';
import home from './pages/home';
import business from './pages/business-profile';
import connectProvider from './pages/connect-provider';
import inviteCustomerInStore from './pages/invite-customer-in-store';

import old from './old';

/**
 * Provisory until the dashboard internationalization is finalized
 */
function spreadIntlOldMessages(data: Record<string, any>) {
  return Object.entries(data).reduce((acc, curr) => {
    const [lang, langData] = curr;

    const transformedLangData = Object.entries(langData).reduce(
      (acc, curr: any) => {
        const [topic, messages] = curr;

        if (topic === 'old') {
          return {
            ...acc,
            ...messages
          };
        }

        return {
          ...acc,
          [topic]: messages
        };
      },
      {}
    );

    return {
      ...acc,
      [lang]: transformedLangData
    };
  }, {});
}

const transformedIntlMessages = composition(
  transformIntlMessages,
  spreadIntlOldMessages
);

const intlData = {
  common,
  menus,
  appIntegrations,
  coinLoyaltySettings,
  referralProgram,
  myTools,
  performance,
  sellCoins,
  customerImport,
  offers,
  emailAutomation,
  home,
  business,
  old,
  connectProvider,
  programStatus,
  modals,
  emailFeedback,
  inviteCustomerInStore
};

const messages = transformedIntlMessages(intlData);

export default messages;
